import { render, staticRenderFns } from "./blankLayout.vue?vue&type=template&id=597fba4e"
import script from "./blankLayout.vue?vue&type=script&lang=js"
export * from "./blankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports